import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "utils/api";
import { LoanModel } from "../../../providers/loans/loan.model";
import { useTenant } from "modules/tenant/providers/tenant-provider";

const getLoanQueryCacheKey = (id: string) => ["loan", id];

const fetchLoan = async (id: string) => {
  const response = await apiRequest("/supabase/loans/single", { id });
  return response.loan;
};

export const useLoanQuery = (id: string) => {
  const { user } = useTenant();

  return useQuery<LoanModel>({
    queryKey: getLoanQueryCacheKey(id),
    queryFn: () => fetchLoan(id),
    enabled: !!id && !!user?.id,
  });
};
